var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileHeaderLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58089 20.384H0V27.9649H7.58089V20.384Z",
    fill: "#FF5043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4543 20.3839H12.9438L18.2364 15.0914L18.2716 15.0562L23.5993 9.72842C20.6538 6.7829 15.8776 6.77116 12.9204 9.69321L7.59262 15.021V0C3.42666 0 0.0469405 3.34451 0 7.48701V15.0679H0.0234702L3.26236 11.829C3.55574 11.5356 4.02515 11.5356 4.31852 11.829L7.55742 15.0679L12.8734 20.3839V27.9648H28C28 23.7871 24.6203 20.4074 20.4543 20.3839Z",
    fill: "#FF5043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHeaderLogo);
export default __webpack_public_path__ + "static/media/MobileHeaderLogo.9c312224ad1ba68dff68975974995582.svg";
export { ForwardRef as ReactComponent };